export default __webpack_public_path__ + "static/media/no_img_co_research.ab3ec1ee.png";